import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-gray-600 body-font">
      <div className="container-fluid bg-gradient-to-r to-[#8ecb27] from-[#3f9422] px-5 py-8">
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <Link to="/" className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
            <img src="/images/logo.png" className="w-10 h-10 text-white bg-grey-500 rounded-full" alt="Prime Lawn Logo" />
            <span className="ml-3 text-xl">Prime Lawn & Snow Management</span>
          </Link>

          <div className="flex flex-col gap-2 text-sm font-semibold text-blue-900 md:items-end">
            <a href="tel:+17057950759" className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-5 h-5" viewBox="0 0 24 24">
                <path d="M6.62 10.79a15.093 15.093 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.07 21 3 13.93 3 5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.24 1.02l-2.2 2.2z"/>
              </svg>
              Call Us: +1 (705) 795-0759
            </a>

            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=primelawnsnowmanagement@gmail.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-5 h-5" viewBox="0 0 24 24">
                <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v.01L12 13 2 4.01V4zm0 2.236v13.764A2 2 0 0 0 4 22h16a2 2 0 0 0 2-2V6.236l-9.197 7.424a1 1 0 0 1-1.606 0L2 6.236z"/>
              </svg>
              primelawnsnowmanagement@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-5 flex flex-col items-center justify-between gap-4 border-t border-black/10 pt-5 sm:flex-row">
          <p className="text-sm text-black">
            © Prime Lawn & Snow Management — All rights reserved
          </p>

          <span className="inline-flex items-center justify-center gap-3">
            <a className="text-blue-900" href="https://m.facebook.com/primelawnsnowmanagement" target="_blank" rel="noopener noreferrer">
              <svg fill="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-8 h-8" viewBox="0 0 24 24">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
              </svg>
            </a>

            <a className="text-red-500" href="https://www.instagram.com/primelawnsnowmanagement" target="_blank" rel="noopener noreferrer">
              <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-8 h-8" viewBox="0 0 24 24">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>

            <a className="text-gray-700" href="https://mail.google.com/mail/?view=cm&fs=1&to=primelawnsnowmanagement@gmail.com" target="_blank" rel="noopener noreferrer">
              <svg fill="currentColor" className="w-8 h-8" viewBox="0 0 24 24">
                <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v.01L12 13 2 4.01V4zm0 2.236v13.764A2 2 0 0 0 4 22h16a2 2 0 0 0 2-2V6.236l-9.197 7.424a1 1 0 0 1-1.606 0L2 6.236z"/>
              </svg>
            </a>

            <a className="text-white" href="https://maps.google.com/?q=Prime+Lawn+%26+Snow+Management" target="_blank" rel="noopener noreferrer" aria-label="Location">
              <svg viewBox="0 0 24 24" className="w-8 h-8 fill-current" aria-hidden="true">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"/>
              </svg>
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;